import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RatesheetLevels } from '../../enums/ratesheet-levels.enum';

export interface RSConfirmPayload {
  applyInTeamTask?: boolean;
  applyInChannelSuggestion?: boolean;
  applyInAllActionTeams?: boolean;
}

@Component({
  selector: 'md-rs-confirm-popup',
  templateUrl: './rs-confirm-popup.component.html',
  styleUrls: ['./rs-confirm-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RSConfirmPopupComponent implements OnInit {
  set applyInTeamTask(value: boolean) {
    this._applyInTeamTask =
      value || this._applyInAllActionTeams || this._applyInChannelSuggestion
        ? value
        : true;
    this._applyInAllActionTeams = false;
    this._applyInChannelSuggestion = false;
  }

  get applyInChannelSuggestion(): boolean {
    return this._applyInChannelSuggestion;
  }

  set applyInChannelSuggestion(value: boolean) {
    this._applyInChannelSuggestion = value;
    this._applyInTeamTask = value ? false : true;
    this._applyInAllActionTeams =
      this.data.ratesheetLevels === RatesheetLevels.ChannelSuggestion && value
        ? false
        : !value
        ? value
        : this.applyInAllActionTeams;
  }

  get applyInAllActionTeams(): boolean {
    return this._applyInAllActionTeams;
  }

  set applyInAllActionTeams(value: boolean) {
    this._applyInAllActionTeams = value;
    this._applyInTeamTask =
      this._applyInChannelSuggestion || this._applyInAllActionTeams ? false : true;
    this._applyInChannelSuggestion =
      value && this.data.ratesheetLevels === RatesheetLevels.ChannelSuggestion
        ? false
        : this._applyInChannelSuggestion;
  }

  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  get applyInTeamTask(): boolean {
    return this._applyInTeamTask;
  }

  get isTeamTask(): boolean {
    return this.data.ratesheetLevels === RatesheetLevels.TeamTask;
  }

  _applyInTeamTask = this.isTeamTask;
  _applyInAllActionTeams = !this.isTeamTask;
  _applyInChannelSuggestion = false;
  RatesheetLevels = RatesheetLevels;

  constructor(
    public dialogRef: MatDialogRef<RSConfirmPopupComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { ratesheetLevels: RatesheetLevels; id: string },
  ) {}

  ngOnInit(): void {}

  submit() {
    const { applyInAllActionTeams, applyInChannelSuggestion, applyInTeamTask } = this;

    this.dialogRef.close({
      applyInAllActionTeams,
      applyInChannelSuggestion,
      applyInTeamTask,
    } as RSConfirmPayload);
  }

  close() {
    this.dialogRef.close();
  }
}
